import { cn } from '@/utils/tailwind';

export function BannerWithIcon(props: {
  children: React.ReactNode;
  icon?: React.ReactNode;
  noIcon?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'rounded-xl bg-secondary px-4 py-4',
        props.noIcon && 'pl-4',
        props.className
      )}
    >
      <div className="flex items-center justify-start gap-3">
        {!props.noIcon && <div className="relative h-5 w-5">{props.icon}</div>}
        {props.children}
      </div>
    </div>
  );
}
